var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.72 11.28C35.2368 13.7976 36.9505 17.0049 37.6446 20.4964C38.3386 23.9879 37.9818 27.6068 36.6193 30.8955C35.2567 34.1843 32.9496 36.9951 29.9897 38.9727C27.0297 40.9503 23.5498 42.0059 19.99 42.0059C16.4302 42.0059 12.9503 40.9503 9.99035 38.9727C7.03039 36.9951 4.72328 34.1843 3.36073 30.8955C1.99818 27.6068 1.64138 23.9879 2.33543 20.4964C3.02949 17.0049 4.74324 13.7976 7.26 11.28M20 2.00003V22",
    stroke: "#07587F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/PowerIcon.77093f49e6ac885f9a88bb42a8eee4a2.svg";
export { ForwardRef as ReactComponent };